import { c as _c } from "react/compiler-runtime";
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import * as React from 'react';
import { cn } from '@/lib/utils';
type PositionerProps = Pick<React.ComponentProps<typeof PopoverPrimitive.Positioner>, 'align' | 'alignOffset' | 'anchor' | 'collisionBoundary' | 'collisionPadding' | 'side' | 'sideOffset' | 'sticky'>;
type PortalProps = Pick<React.ComponentProps<typeof PopoverPrimitive.Portal>, 'container' | 'keepMounted'>;
function Popover(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PopoverPrimitive.Root data-slot="popover" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function PopoverTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function PopoverContent(t0) {
  const $ = _c(32);
  let alignOffset;
  let anchor;
  let className;
  let collisionBoundary;
  let collisionPadding;
  let container;
  let keepMounted;
  let props;
  let side;
  let sticky;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      alignOffset,
      anchor,
      collisionBoundary,
      collisionPadding,
      container,
      keepMounted,
      side,
      sideOffset: t2,
      sticky,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alignOffset;
    $[2] = anchor;
    $[3] = className;
    $[4] = collisionBoundary;
    $[5] = collisionPadding;
    $[6] = container;
    $[7] = keepMounted;
    $[8] = props;
    $[9] = side;
    $[10] = sticky;
    $[11] = t1;
    $[12] = t2;
  } else {
    alignOffset = $[1];
    anchor = $[2];
    className = $[3];
    collisionBoundary = $[4];
    collisionPadding = $[5];
    container = $[6];
    keepMounted = $[7];
    props = $[8];
    side = $[9];
    sticky = $[10];
    t1 = $[11];
    t2 = $[12];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  let t3;
  if ($[13] !== className) {
    t3 = cn("z-50 w-72 origin-(--transform-origin) rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", "[--sq-r:1.125rem] sq:rounded-(--sq-r) sq:shadow-none sq:drop-shadow-lg", className);
    $[13] = className;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== props || $[16] !== t3) {
    t4 = <PopoverPrimitive.Popup data-slot="popover-content" className={t3} {...props} />;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== align || $[19] !== alignOffset || $[20] !== anchor || $[21] !== collisionBoundary || $[22] !== collisionPadding || $[23] !== side || $[24] !== sideOffset || $[25] !== sticky || $[26] !== t4) {
    t5 = <PopoverPrimitive.Positioner align={align} alignOffset={alignOffset} anchor={anchor} collisionBoundary={collisionBoundary} collisionPadding={collisionPadding} side={side} sideOffset={sideOffset} sticky={sticky}>{t4}</PopoverPrimitive.Positioner>;
    $[18] = align;
    $[19] = alignOffset;
    $[20] = anchor;
    $[21] = collisionBoundary;
    $[22] = collisionPadding;
    $[23] = side;
    $[24] = sideOffset;
    $[25] = sticky;
    $[26] = t4;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== container || $[29] !== keepMounted || $[30] !== t5) {
    t6 = <PopoverPrimitive.Portal keepMounted={keepMounted} container={container}>{t5}</PopoverPrimitive.Portal>;
    $[28] = container;
    $[29] = keepMounted;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}
function PopoverAnchor(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <div data-slot="popover-anchor" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };